export const LOADBOOK = "Book/load_book";
export const ADDBOOK = "Book/add_book";
export const LOADEDITBOOK = "Book/load_edit_book";
export const EDITBOOK = "Book/edit_book";
export const DELETEBOOK = "Book/delete_book";
export const SEARCHBOOK = "Book/search_book";
export const FILTERBOOK = "Book/filter_book";
